export default __webpack_public_path__ + "static/insights-cb01c4382e3e8ee3d92265f763ee72c1.jpg";